import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=1770906f&"
import script from "./setting.vue?vue&type=script&lang=js&"
export * from "./setting.vue?vue&type=script&lang=js&"
import style0 from "./setting.vue?vue&type=style&index=0&id=1770906f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports